import Constants from "constants/index";
import MedkitService from "./medkit.service";
import { IRecordTag } from "commons/interfaces";


class TagService extends MedkitService {

    public getAll = async (): Promise<IRecordTag[]> => {
        const result = await this.api.get({ path: Constants.ApiPath.TAG.GET_ALL });
        return result.data.result;
    }

    public create = async (data: { tagName: string }): Promise<IRecordTag> => {
        const result = await this.api.post({ path: Constants.ApiPath.TAG.CREATE, data });
        return result.data.result;
    }

};

export default TagService;